import { IBatteryInputDto, ISaveBatteryInputData } from '@/interfaces/storageForecasting/IBatteryInputData.ts';
import { IAssetInputDto, ISaveAssetInputData, ISaveInputReturn } from '@/interfaces/storageForecasting/IAsset.ts';
import { IAssetPresetsResponse } from '@/interfaces/storageForecasting/IAssetPreset.ts';
import { IAssumptionDetails } from '@/interfaces/storageForecasting/IAssumptionDetails.ts';
import { IInputShared } from '@/interfaces/storageForecasting/IInputShared.ts';
import {
    canonicaliseSaveAssetInputData,
    canonicaliseSaveBatteryInputData,
} from '@/utils/storageForecasting/inputPayloadUtils.ts';
import { apiAbortOptions, useApi } from '../useApi.ts';

const apiCall = useApi('storageForecasting');

async function getInputList (): Promise<Array<IBatteryInputDto>> {
    return (await apiCall.get<Array<IBatteryInputDto>>({ endpoint: '/api/InputList', extraScopeOptions: { allowCaching: false } })).data;
}

async function getInputListNew (signal?: AbortSignal): Promise<Array<IAssetInputDto>> {
    return (await apiCall.get<Array<IAssetInputDto>>({
        endpoint: '/api/InputListNew',
        extraScopeOptions: { allowCaching: false, ...apiAbortOptions(signal).extraScopeOptions },
    })).data;
}

async function getAssetPresets (): Promise<IAssetPresetsResponse> {
    return (await apiCall.get<IAssetPresetsResponse>({
        endpoint: '/api/DefaultInputs',
        extraScopeOptions: { allowCaching: false },
    })).data;
}

async function saveInputs (newInputs: ISaveBatteryInputData): Promise<Record<string, string>> {
    return (await apiCall.post<ISaveBatteryInputData, Record<string, string>>({
        endpoint: '/api/SaveInputs',
        payload: canonicaliseSaveBatteryInputData(newInputs),
    })).data;
}

async function saveInputsWithoutBattery (newInputs: ISaveAssetInputData): Promise<ISaveInputReturn> {
    return (await apiCall.post<ISaveAssetInputData, ISaveInputReturn>({
        endpoint: '/api/SaveInputsWithoutBattery',
        payload: canonicaliseSaveAssetInputData(newInputs),
    })).data;
}

async function deleteInput (inputIdValue: string): Promise<void> {
    await apiCall.post<{inputId: string}, void>({ endpoint: '/api/DeleteInput', payload: { inputId: inputIdValue } });
}
async function shareInput (inputIdValue: string, userToShareTo: string):Promise<IInputShared> {
    return (await apiCall.post<{inputIdToSend: string; userIdToSendTo: string}, IInputShared>({ endpoint: '/api/CloneAssetToOtherUser', payload: { inputIdToSend: inputIdValue, userIdToSendTo: userToShareTo } })).data;
}

async function getAssumptionsList (): Promise<Array<IAssumptionDetails>> {
    return (await apiCall.get<Array<IAssumptionDetails>>({ endpoint: '/api/GetAssumptionsList' })).data;
}

async function getPowerCurvesAssumptionList (): Promise<Array<IAssumptionDetails>> {
    return (await apiCall.get<Array<IAssumptionDetails>>({ endpoint: '/api/GetPowerCurvesAssumptionsList' })).data;
}

async function getApplicationVersions (): Promise<Array<string>> {
    return (await apiCall.get<Array<string>>({ endpoint: '/api/GetApplicationVersions' })).data;
}

export const inputApi = {
    getInputList,
    getInputListNew,
    getAssetPresets,
    saveInputs,
    saveInputsWithoutBattery,
    deleteInput,
    shareInput,
    getAssumptionsList,
    getPowerCurvesAssumptionList,
    getApplicationVersions,
};
